import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDateNaissanceInconnueFRFromYYYYMMDD } from 'components/Commun/Form/Date/dateTranformation';
import styles from './InformationsPersonnellesImpressionRatelier.module.scss';

const InformationsPersonnellesImpressionRatelier = ({ informationsPersonnelles, titre }) => {
    const getNomUsage = () => {
        if (!informationsPersonnelles) {
            return '';
        }
        if (informationsPersonnelles.nomUsage) {
            return informationsPersonnelles.nomUsage;
        }
        return informationsPersonnelles.nom;
    };

    const getPrenomUsuel = () => {
        if (!informationsPersonnelles) {
            return '';
        }
        if (informationsPersonnelles.prenomUsuel) {
            return informationsPersonnelles.prenomUsuel;
        }
        return informationsPersonnelles.prenomUn;
    };

    const dateNaissance = informationsPersonnelles
        ? getDateNaissanceInconnueFRFromYYYYMMDD(informationsPersonnelles.dateNaissance)
        : '';

    const sexe = informationsPersonnelles ? informationsPersonnelles.sexe : '';

    const lieuNaissance = informationsPersonnelles ? informationsPersonnelles.lieuNaissance : '';
    const codePostalNaissance = informationsPersonnelles
        ? informationsPersonnelles.codePostalNaissance
        : '';

    const paysNaissance = informationsPersonnelles
        ? informationsPersonnelles.paysNaissance.libelle
        : '';
    const nationalite = informationsPersonnelles
        ? informationsPersonnelles.nationalite.libelle
        : '';

    return (
        <>
            {titre && (
                <div className={styles['InformationsPersonnellesImpressionRatelier-Titre']}>
                    {titre}
                </div>
            )}
            <div className={styles['InformationsPersonnellesImpressionRatelier-Line']}>
                {getNomUsage()} {getPrenomUsuel()}
            </div>
            <div className={styles['InformationsPersonnellesImpressionRatelier-Line']}>
                Sexe : {sexe}
            </div>
            <div className={styles['InformationsPersonnellesImpressionRatelier-Line']}>
                Né(e) le {dateNaissance} à {lieuNaissance} ({codePostalNaissance}), {paysNaissance}
            </div>
            <div className={styles['InformationsPersonnellesImpressionRatelier-Line']}>
                Nationalité : {nationalite}
            </div>
        </>
    );
};

InformationsPersonnellesImpressionRatelier.propTypes = {
    informationsPersonnelles: PropTypes.shape({
        nom: PropTypes.string.isRequired,
        nomUsage: PropTypes.string.isRequired,
        prenomUsuel: PropTypes.string.isRequired,
        prenomUn: PropTypes.string.isRequired,
        sexe: PropTypes.string,
        dateNaissance: PropTypes.string,
        lieuNaissance: PropTypes.string,
        codePostalNaissance: PropTypes.string,
        paysNaissance: PropTypes.shape({
            libelle: PropTypes.string.isRequired,
        }).isRequired,
        nationalite: PropTypes.shape({
            libelle: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    titre: PropTypes.string,
};

InformationsPersonnellesImpressionRatelier.defaultProps = {};

export default connect()(InformationsPersonnellesImpressionRatelier);
